import { NavLink } from "react-router-dom";
import Icon from "../components/Icon";
import AccountNavButton from "./AccountNavButton";

/**
 * Mobile bottom tab-bar (hidden on desktop via existing CSS).
 *
 * Order: Overview · History · Analysis · Account. Account carries the
 * notification badge and routes to the account page.
 */
export default function TabBar() {
  return (
    <nav className="tab-bar" aria-label="Primary">
      <NavLink
        to="/"
        end
        aria-label="Overview"
        className={({ isActive }) =>
          "tab-bar__item" + (isActive ? " tab-bar__item--active" : "")
        }
      >
        <Icon name="fuel" className="tab-bar__icon" />
      </NavLink>
      <NavLink
        to="/history"
        aria-label="History"
        className={({ isActive }) =>
          "tab-bar__item" + (isActive ? " tab-bar__item--active" : "")
        }
      >
        <Icon name="clock" className="tab-bar__icon" />
      </NavLink>
      <NavLink
        to="/analysis"
        aria-label="Analysis"
        className={({ isActive }) =>
          "tab-bar__item" + (isActive ? " tab-bar__item--active" : "")
        }
      >
        <Icon name="chart" className="tab-bar__icon" />
      </NavLink>
      <AccountNavButton variant="tab" />
    </nav>
  );
}
